export default "__VITE_ASSET__TAbt5eER__"